import { HorizBox, HoverView, Pad, PadBox } from "component/basics";
import { colorAmbiguousAccent, colorAmbiguousWhite, colorBorderPrimary, colorButtonAccent, colorGreyFormHover, colorGreyFormPress, colorTagHighlight } from "component/color";
import { UtilityText } from "component/text";
import { useTranslation } from "component/translation";
import { StyleSheet, View } from "react-native";
import { undefA, undefS } from "util/stdtypes";


export type ToggleSize = 'regular' | 'compact';

/** Extended version of the `Toggle` button
 * @param disabled Optional disabled state to prevent pointer events and keyboard navigation via tab. The disabled state has no visual impact.
 * @param size Allows choosing between a regular version and a compact version of the toggle button with vertical padding removed
 */
export function REPLACE_ZDF_Toggle({emoji = undefS, text = undefS, label = undefS, value = false, spread = false, onChange = undefA, testID = undefS, disabled = false, size = "regular" as ToggleSize}) {
    const s = ToggleStyle;
    const tLabel = useTranslation(label);
    return <HoverView hoverStyle={s.hover} testID={testID ?? label ?? text}
        onPress={() => onChange(!value)} role='button' shrink
        ariaText={value ? `${text ?? tLabel}, checked` : `${text ?? tLabel}, unchecked`}
        disabled={disabled}
        style={s.outer}
    >
        <PadBox vert={size === "compact" ? 0 : 8}>
            <HorizBox center spread={spread} shrink>        
                <HorizBox center shrink>
                    {emoji && <PadBox right={8}><UtilityText aria-hidden text={emoji} type='tiny' weight='strong' /></PadBox>}
                    <UtilityText text={text} label={label} />
                </HorizBox>
                <Pad size={12} />
                <View style={value ? s.toggleZoneSelected : s.toggleZone} >
                    <View style={value ? s.toggleBallSelected : s.toggleBall} />
                </View>
            </HorizBox>
        </PadBox>
    </HoverView>
}

const ToggleStyle = StyleSheet.create({
    outer: {
        overflow: "hidden"
    },
    toggleZone: {
        width: 56,
        height: 32,
        backgroundColor: colorBorderPrimary,
        borderRadius: 100,
        ...{transition: 'background-color 0.2s ease-in-out'} as any
    },
    toggleBall: {
        boxShadow: '2px 0px 10px rgba(0, 0, 0, 0.30)' as any, // FIXME: boxShadow not typed for native
        elevation: 5,  // for Android,
        position: 'absolute',
        left: 2,
        top: 2,
        width: 28,
        height: 28,
        borderRadius: 100,
        backgroundColor: colorAmbiguousWhite,
        ...{transition: 'left 0.2s ease-in-out, background-color 0.2s ease-in-out'} as any
    },
    toggleZoneSelected: {
        width: 56,
        height: 32,
        backgroundColor: colorTagHighlight,
        borderRadius: 100,
        ...{transition: 'background-color 0.2s ease-in-out'} as any
    },
    toggleBallSelected: {
        backgroundColor: colorButtonAccent,
        left: 56-28-2,
        top: 2,
        width: 28,
        height: 28,
        borderRadius: 100,
        ...{transition: 'left 0.2s ease-in-out, background-color 0.2s ease-in-out'} as any
    },
    hover: {
        backgroundColor: colorGreyFormHover,
    },
    pressed: {
        backgroundColor: colorGreyFormPress,
        borderTopRightRadius: 100,
        borderBottomRightRadius: 100,
    }
})
